var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6321 16.104C15.5553 14.8192 12.7345 13.8752 11.3841 13.7296C10.0353 13.5808 7.60488 12.6192 9.79368 11.6304C11.8017 10.7232 13.7057 11.5696 14.4001 11.9632C14.3937 11.9568 14.3841 11.952 14.3777 11.9488L11.6145 7.59044L11.2353 7.04004C11.2353 7.04004 6.99528 7.16964 5.43848 10.312C3.87688 13.448 4.79688 15.3488 7.35528 16.6864C9.91528 18.0272 13.0337 17.928 13.9345 18.9264C14.2545 19.2816 14.3089 19.6016 14.2433 19.864L16.6625 16.1344C16.6433 16.1136 16.6305 16.1056 16.6305 16.1056L16.6321 16.104Z",
    fill: "url(#paint0_linear_534_272)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6353 20.6272C9.51527 22.0256 7.69767 18.6672 7.69767 18.6672L4.32007 21.2672C6.77767 24.4032 10.3169 24.8656 10.3169 24.8656C10.5297 24.904 10.7361 24.9328 10.9409 24.96L13.8625 20.456C13.7409 20.568 13.6369 20.6272 13.6369 20.6272H13.6353Z",
    fill: "url(#paint1_linear_534_272)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6784 16.1328L14.2592 19.8624C14.1968 20.12 14.0224 20.3264 13.8752 20.4544L10.9504 24.9584C12.6976 25.0352 14.0464 24.728 15.0752 24.2656C17.104 23.24 18.0448 21.5232 18.0448 21.5232C18.8272 18.5072 16.9408 16.408 16.6768 16.1312L16.6784 16.1328Z",
    fill: "url(#paint2_linear_534_272)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1152 7.04164L14.5648 12.1376C14.5648 12.1376 14.4896 12.088 14.3552 12.0064C14.7328 12.2432 15.1136 12.7296 15.1136 12.7296L17.5552 9.30884C15.9344 7.23044 11.1168 7.04004 11.1168 7.04004L11.1152 7.04164Z",
    fill: "#5ED6AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4738 10.3888L17.5538 9.31042L15.1138 12.7296L22.6914 24.2672H27.7714L18.4738 10.3888Z",
    fill: "url(#paint3_linear_534_272)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1313 7.71204L16.6641 16.1344C16.9281 16.4112 18.8145 18.5104 18.0321 21.5264L27.2097 7.71204H22.1313Z",
    fill: "#4BC5A7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.6784 16.1328L14.2592 19.8624C14.1968 20.12 14.0224 20.3264 13.8752 20.4544L10.9504 24.9584C12.6976 25.0352 14.0464 24.728 15.0752 24.2656C17.104 23.24 18.0448 21.5232 18.0448 21.5232C18.8272 18.5072 16.9408 16.408 16.6768 16.1312L16.6784 16.1328Z",
    fill: "#59D1AF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_534_272",
    x1: 4.67368,
    y1: 13.4528,
    x2: 16.6641,
    y2: 13.4528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2269D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2333A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_534_272",
    x1: 4.31847,
    y1: 21.8144,
    x2: 13.8609,
    y2: 21.8144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2269D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2333A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_534_272",
    x1: 10.952,
    y1: 20.552,
    x2: 18.2352,
    y2: 20.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2269D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2333A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_534_272",
    x1: 15.1138,
    y1: 16.7888,
    x2: 27.7714,
    y2: 16.7888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ED6AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059CC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSx);
export default __webpack_public_path__ + "static/media/sx.3d8a4b544258b3ba0655c01e3cdf5597.svg";
export { ForwardRef as ReactComponent };